<template>
	<div style="background-color: #fff;min-height: 100vh;padding: 1vh 1vw;">
		<div style="margin-bottom: 4vh;">
			<el-page-header @back="$router.back()" content="报价详情"></el-page-header>
		</div>
		<!--价格表信息-->
		<div>
			<el-descriptions class="margin-top" title="基础信息" :column="2" border>
				<el-descriptions-item>
					<template #label>
						<span>价格表名称</span>
					</template>
					<el-input v-model="PriceBasic.PriceListName" placeholder="请输入名称" style="width: 40%;"></el-input>
				</el-descriptions-item>
				<el-descriptions-item>
					<template #label>
						<span>备注</span>
					</template>
					<el-input v-model="PriceBasic.Remark" placeholder="请输入备注" style="width: 40%;"></el-input>
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<!--价格表详情-->
		<div style="margin-top: 3vh;">
			<div class="price-list-body" v-for="(i,partitionIndex) in PriceListData" :key="i">
				<div class="price-list-group">
					<!--分区-->
					<div style="width: 10%;" class="price-list-row price-list-group-front">
						<el-input v-model="PriceListData[partitionIndex].PriceGroupName" placeholder="请输入内容"></el-input>
						<el-button v-if="partitionIndex == PriceListData.length-1"
							@click="addPriceGroup(partitionIndex)" style="margin-left: 3%;" type="primary" icon="Plus" circle></el-button>
					</div>
					<!--目的地-->
					<div @click="editPriceProvince(partitionIndex)" style="width: 20%;cursor: pointer;display: block;"
						class="price-list-row price-list-group-front">
						<el-tag :closable="true" v-for="(i2,AreaListIndex) in i.AreaList" :key="i2"
							@close="RemoveSelectionArea(partitionIndex,AreaListIndex)"
							style="margin: 0.4rem;">{{i2.area_name}}</el-tag>
						<div v-if="i.AreaList.length<1" style="color: #b8b8b8;margin-top: 5%;">点击编辑</div>
					</div>
					<!--目的地选择右侧弹出层-->
					<el-drawer title="配置分组目的地" v-model="showPriceProvince" direction="rtl">
						<div style="padding: 2%;">
							<div v-for="(ZoneItem,ZoneIndex) in objectiveAreaList" :key="ZoneItem"
								style="margin-top: 1rem;border-bottom: 1px solid #dcdfe6;">
								<!--分区-->
								<div style="cursor: pointer;">
									<el-tag
										@click="selectArea(partitionIndex=showPriceProvinceIndex,ZoneIndex,ProvinceIndex=null,'zones')">{{ZoneItem.area_name}}</el-tag>
								</div>
								<!--省份-->
								<div style="margin-top: 1rem;">
									<!-- <el-checkbox-button v-for="(ProvinceItem,ProvinceIndex) in ZoneItem.children" @change="selectArea(partitionIndex,ZoneIndex,ProvinceIndex,'province')" :label="area_name" :key="area_code" style="margin: 4px;" >
										<span >{{ProvinceItem.area_name}}</span>
									</el-checkbox-button>	 -->
									<div v-for="(ProvinceItem,ProvinceIndex) in ZoneItem.children" :key="ProvinceItem"
										@click="selectArea(partitionIndex=showPriceProvinceIndex,ZoneIndex,ProvinceIndex,'province')"
										:style="{'background':detectingSelectionArea(showPriceProvinceIndex,ProvinceItem) ? '#409eff': '#ecf5ff','color':detectingSelectionArea(showPriceProvinceIndex,ProvinceItem)? '#fff': '#409eff'}"
										style="border-radius: 4px;text-align: center;padding: 6px;margin: 3px;;display: inline-block;cursor: pointer;">
										<span>{{ProvinceItem.area_name}}</span>
									</div>
								</div>
							</div>
						</div>
					</el-drawer>
					<!--重量段及价格设置-->
					<div style="width: 75%;" class="price-list-row price-list-group-after">
						<div v-for="(i3,PriceDetailsIndex) in i.PriceDetails" :key="i3"
							style="border-bottom: 1px solid #dcdfe6;">
							<!--  -->
							<div style="margin: 0 0 0 0;display: flex;align-items: center;">
								<!--重量段-->
								<div>
									<el-input-number style="width: 30%;margin-top: 0;"
										v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].MinWeight"
										:controls="false" :precision="2"
										:min="(PriceDetailsIndex <= 0) ? 0.01 : PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex-1].MaxWeight+0.01"
										:max="999"></el-input-number>
									<span style="margin: 0 10px 0 10px;">-</span>
									<el-input-number style="margin-top: 2px;"
										v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].MaxWeight"
										:controls="false" :precision="2"
										:min="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].MinWeight+0.01"
										:max="9919"></el-input-number>
								</div>
								<!--计费方式类型-->
								<div style="width: 15%;margin-left: 2%;">
									<el-select
										v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.ChargeModel"
										placeholder="请选择">
										<el-option v-for="item in calculationType" :key="item.code" :label="item.name"
											:value="item.code"></el-option>
									</el-select>
								</div>
								<!--价格设置-->
								<div class="price-set" style="width: 53%;">
									<!--固定价格-->
									<div
										v-if="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.ChargeModel == 'Fixed'">
										<el-input placeholder="请输入价格"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.FixedPrice.Price">
											<template #append>元</template>
										</el-input>
									</div>
									<!--简单重量-->
									<div
										v-else-if="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.ChargeModel == 'SimpleWeight'">
										<el-input placeholder="请输入价格"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.SimpleWeight.Price">
											<template #append>元</template>
										</el-input>
										<el-input placeholder="请输入重量"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.SimpleWeight.Weight">
											<template #append>公斤</template>
										</el-input>
									</div>
									<!--首续重-->
									<div
										v-else-if="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.ChargeModel == 'FirstContinuing'">
										<el-input placeholder="请输入"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.FirstContinuing.FirstWeight">
											<template #prepend>首重重量</template>
											<!-- <template #append>公斤</template> -->
										</el-input>
										<el-input placeholder="请输入"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.FirstContinuing.FirstPrice">
											<template #prepend>首重价格</template>
											<!-- <template #append>元</template> -->
										</el-input>
										<br />
										<el-input placeholder="请输入"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.FirstContinuing.ContinuedWeight">
											<template #prepend>续重重量</template>
											<!-- <template #append>公斤</template> -->
										</el-input>
										<el-input placeholder="请输入"
											v-model="PriceListData[partitionIndex].PriceDetails[PriceDetailsIndex].calculation.FirstContinuing.ContinuedPrice">
											<template #prepend>续重价格</template>
											<!-- <template #append>元</template> -->
										</el-input>
									</div>
								</div>
							</div>
							<div v-if="PriceDetailsIndex == PriceListData[partitionIndex].PriceDetails.length-1">
								<el-button v-if="PriceDetailsIndex<8"
									@click="addWeightRange(partitionIndex,PriceDetailsIndex)" style="margin-left: 3%;"
									type="primary" icon="Plus" circle></el-button>
								<el-button v-if="PriceDetailsIndex>0"
									@click="deleteWeightRange(partitionIndex,PriceDetailsIndex)"
									style="margin-left: 3%;" type="primary" icon="Minus" 
									circle></el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="padding: 10% 40%;">
			<el-button type="primary" @click="submitPriceList()">保存</el-button>
		</div>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				PriceBasic: {
					PriceListName: "",
					Remark: ""
				},
				PriceListData: [{
					PriceGroupName: '一区',
					AreaList: [],
					PriceDetails: [{
						MinWeight: 0.01,
						MaxWeight: 1.00,
						calculation: {
							ChargeModel: 'Fixed',
							FixedPrice: {
								Price: 0
							},
							SimpleWeight: {
								Price: 0,
								Weight: 1
							},
							FirstContinuing: {
								FirstWeight: 1,
								FirstPrice: 0,
								ContinuedWeight: 1,
								ContinuedPrice: 0
							}
						},
					}]
				}],
				calculationType: [{
						name: '固定价格',
						code: 'Fixed'
					},
					{
						name: '简单重量',
						code: 'SimpleWeight'
					},
					{
						name: '首/续重',
						code: 'FirstContinuing'
					},
					{
						name: '步进价格',
						code: 'Stepping'
					}
				],
				showPriceProvince: false,
				showPriceProvinceIndex: null,
				objectiveAreaList: [{
						area_code: 1,
						area_name: '华东地区',
						children: [{
								area_name: '上海',
								area_code: '310000'
							},
							{
								area_name: '浙江',
								area_code: '330000'
							},
							{
								area_name: '江苏',
								area_code: '320000'
							},
							{
								area_name: '安徽',
								area_code: '340000'
							},
							{
								area_name: '江西',
								area_code: '360000'
							},
							{
								area_name: '福建',
								area_code: '350000'
							},
							{
								area_name: '山东',
								area_code: '370000'
							}
						]
					},
					{
						area_code: 2,
						area_name: '华南地区',
						children: [{
								area_name: '广东',
								area_code: '440000',
								children: [{
									area_name: '深圳',
									area_code: '440300'
								}, ]
							},
							{
								area_name: '广西',
								area_code: '450000'
							},
							{
								area_name: '海南',
								area_code: '460000'
							}
						]
					},
					{
						area_code: 3,
						area_name: '华北地区',
						children: [{
								area_name: '北京',
								area_code: '110000'
							},
							{
								area_name: '天津',
								area_code: '120000'
							},
							{
								area_name: '河北',
								area_code: '130000'
							},
							{
								area_name: '山西',
								area_code: '140000'
							},
							{
								area_name: '内蒙古',
								area_code: '150000'
							}
						]
					},
					{
						area_code: 4,
						area_name: '华中地区',
						children: [{
								area_name: '河南',
								area_code: '410000'
							},
							{
								area_name: '湖北',
								area_code: '420000'
							},
							{
								area_name: '湖南',
								area_code: '430000'
							}
						]
					},
					{
						area_code: 5,
						area_name: '西南地区',
						children: [{
								area_name: '四川',
								area_code: '510000'
							},
							{
								area_name: '贵州',
								area_code: '520000'
							},
							{
								area_name: '云南',
								area_code: '530000'
							},
							{
								area_name: '重庆',
								area_code: '500000'
							},
							{
								area_name: '西藏',
								area_code: '540000'
							}
						]
					},
					{
						area_code: 6,
						area_name: '西北地区',
						children: [{
								area_name: '陕西',
								area_code: '610000'
							},
							{
								area_name: '甘肃',
								area_code: '620000'
							},
							{
								area_name: '青海',
								area_code: '630000'
							},
							{
								area_name: '宁夏',
								area_code: '640000'
							},
							{
								area_name: '新疆维吾尔自治区',
								area_code: '650000'
							}
						]
					},
					{
						area_code: 7,
						area_name: '东北地区',
						children: [{
								area_name: '黑龙江',
								area_code: '230000'
							},
							{
								area_name: '吉林',
								area_code: '220000'
							},
							{
								area_name: '辽宁',
								area_code: '210000'
							}
						]
					},
					{
						area_code: 8,
						area_name: '海外地区',
						children: [{
								area_name: '香港',
								area_code: '810000'
							},
							{
								area_name: '澳门',
								area_code: '820000'
							},
							{
								area_name: '台湾',
								area_code: '710000'
							}
						]
					}
				]
			}

		},
		methods: {
			//创建价格表
			submitPriceList() {
				var form = {
					PriceBasic: this.PriceBasic,
					PriceListData: this.PriceListData
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "newCreatePriceList",
						content: form
					})
					.then((res) => {
						//成功
						if (res.status) {
							history.go(-1);
						}
					})
					.finally(() => {
						loading.close();
					})
			},
			getPriceDetails(priceListId) {
				if (priceListId) {
					const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(107, 107, 107, 0.7)'
					});
					this.apiService.post({
							modules: "newPriceDetails",
							content: {
								priceListId: priceListId
							}
						})
						.then((res) => {
							//成功
							if (res.status) {
								this.PriceBasic = res.data.PriceBasic;
								this.PriceListData = res.data.PriceListData;
							}
						})
						.finally(() => {
							loading.close();
						})
				}
			},
			//编辑价格组地区弹窗
			editPriceProvince(partitionIndex) {
				this.showPriceProvince = true
				this.showPriceProvinceIndex = partitionIndex
			},
			//编辑价格组地区弹窗的地区检测是否为已选择/禁用
			detectingSelectionArea(showPriceProvinceIndex, ProvinceItem) {
				console.log('开始检测 编辑价格组地区弹窗的地区检测是否为已选择')
				var isDetectingSelectionArea = false;
				//检测所有价格组是否包含
				this.PriceListData.forEach((PriceListDataItem) => {
					PriceListDataItem.AreaList.forEach((PriceListDataItemAreaListItem) => {
						if (PriceListDataItemAreaListItem.area_name.includes(ProvinceItem.area_name)) {
							isDetectingSelectionArea = true;
						}
					})
					// console.log(PriceListDataItem.AreaList,ProvinceItem)
					// if(PriceListDataItem.AreaList.includes(ProvinceItem)){
					// 	isDetectingSelectionArea = true;
					// }
				})
				return isDetectingSelectionArea
			},
			//选择分组地区
			selectArea(partitionIndex, ZoneIndex, ProvinceIndex, AreaType) {
				//PriceAddAreaList为已添加的省份
				var PriceAddAreaList = this.PriceListData[partitionIndex].AreaList
				//AddAreaList 为本次添加的数据
				var AddAreaList = []
				if (AreaType == 'zones') {
					// AddAreaList.push(...this.objectiveAreaList[ZoneIndex].children);
				} else if (AreaType == 'province') {
					AddAreaList.push(this.objectiveAreaList[ZoneIndex].children[ProvinceIndex]);
				}
				// console.log('PriceAddAreaList',PriceAddAreaList)
				// console.log('AddAreaList',AddAreaList)

				//检测重复
				/* AddAreaList.forEach((AddAreaListItem, AddAreaListIndex) => {
					// PriceAddAreaList.forEach((PriceAddAreaListItem,PriceAddAreaListIndex) => {
					// 	if (AddAreaListItem['area_name'] == PriceAddAreaListItem['area_name']) {
					// 		PriceAddAreaList.splice(PriceAddAreaListIndex, 1);
					// 		AddAreaList.splice(PriceAddAreaListIndex, 1);
					// 	}
					// })
					if (this.detectingSelectionArea(partitionIndex, AddAreaListItem)) {
						PriceAddAreaList.splice(PriceAddAreaListIndex, 1);
						AddAreaList.splice(PriceAddAreaListIndex, 1);
					}

				}) */
				var ConfirmAddAreaList = [...PriceAddAreaList, ...AddAreaList]

				this.PriceListData[partitionIndex].AreaList = ConfirmAddAreaList;
			},
			//移除分组地区
			RemoveSelectionArea(partitionIndex, AreaListIndex) {
				this.PriceListData[partitionIndex].AreaList.splice(AreaListIndex, 1)
			},
			//数字转文字数字，用于分组名称
			numberToChinese(num) {
				var units = ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿'];
				var digits = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];

				var result = String(num).replace(/./g, function(digit, index, array) {
					return digits[Number(digit)] + units[array.length - index - 1];
				});

				return result;
			},
			//新增分区
			addPriceGroup(partitionIndex) {
				//当前项就是最新的上一条
				var previousPartitionPriceDetails = this.PriceListData[partitionIndex]['PriceDetails']
				var PriceDetails = []
				previousPartitionPriceDetails.forEach((item) => {
					var PriceDetailsItem = {
						MinWeight: item.MinWeight,
						MaxWeight: item.MaxWeight,
						calculation: {
							ChargeModel: item.calculation.ChargeModel,
							FixedPrice: {
								Price: 0
							},
							SimpleWeight: {
								Price: 0,
								Weight: 1
							},
							FirstContinuing: {
								FirstWeight: 1,
								FirstPrice: 0,
								ContinuedWeight: 1,
								ContinuedPrice: 0
							}
						},
					}
					PriceDetails.push(PriceDetailsItem)
				})
				var addPartitionData = {
					PriceGroupName: this.numberToChinese(partitionIndex + 2) + '区',
					AreaList: [],
					PriceDetails: PriceDetails
				}
				this.PriceListData.push(addPartitionData)
			},
			//新增重量段
			addWeightRange(partitionIndex, PriceDetailsIndex) {
				//上一条数据
				var previousPriceDetails = this.PriceListData[partitionIndex].PriceDetails
				/* var previousMinWeight = previousPriceDetails[PriceDetailsIndex].MinWeight */
				var previousMaxWeight = previousPriceDetails[PriceDetailsIndex].MaxWeight
				var ChargeModel = previousPriceDetails[PriceDetailsIndex].calculation.ChargeModel;
				var MinWeight = previousMaxWeight + 0.01
				var MaxWeight = MinWeight + 1 - 0.01
				var calculation = {
					ChargeModel: ChargeModel,
					FixedPrice: {
						Price: 0
					},
					SimpleWeight: {
						Price: 0,
						Weight: 1
					},
					FirstContinuing: {
						FirstWeight: 1,
						FirstPrice: 0,
						ContinuedWeight: 1,
						ContinuedPrice: 0
					}
				}
				this.PriceListData[partitionIndex].PriceDetails.push({
					MinWeight: MinWeight,
					MaxWeight: MaxWeight,
					calculation: calculation
				})
				// console.log(this.PriceListData[partitionIndex].PriceDetails)
			},
			//删除重量段
			deleteWeightRange(partitionIndex, PriceDetailsIndex) {
				this.PriceListData[partitionIndex].PriceDetails.splice(PriceDetailsIndex, 1)
			}
		},
		created() {
			var priceListId = this.$route.query.priceListId
			if (priceListId) {
				this.getPriceDetails(priceListId);
			}
		}
	}
</script>

<style scoped>
	.price-set .el-input {
		width: 40%;
		position: relative;
		margin: 4px;
	}

	.price-list-body .price-list-group {
		border: 1px solid #dcdfe6;
		display: flex;
	}

	.price-list-group-front {
		display: flex;
	}

	.price-list-body .price-list-group .price-list-row {
		text-align: center;
		min-width: 60px;
		border-right: 1px solid #dcdfe6;
		/* padding: 6px; */
		align-items: center;
		/* 垂直居中 */
		justify-content: center;
		/* 水平居中 */
	}
</style>